$(document).ready(function() {
	
	// -- Facebook --
  $.ajaxSetup({ cache: true });
  $.getScript('https://connect.facebook.net/en_US/sdk.js', function(){
    FB.init({
      appId: '407311660099675',
      version: 'v3.2',
      xfbml: false,
      autoLogAppEvents: true,
    });

    $('.fb__share a').on('click', function(e){
    	e.preventDefault();
    	var href = $(this).attr('href');
			FB.ui({
			  method: 'share',
			  display: 'popup',
		    href: href,
		    redirect_uri: href,
			  mobile_iframe: true,
			}, function(response){
			  console.log(response);
			});
    });
  });


  // -- Twitter --
	var getWindowOptions = function() {
	  var width = 500;
	  var height = 350;
	  var left = (window.innerWidth / 2) - (width / 2);
	  var top = (window.innerHeight / 2) - (height / 2);

	  return [
	    'resizable,scrollbars,status',
	    'height=' + height,
	    'width=' + width,
	    'left=' + left,
	    'top=' + top,
	  ].join();
	};
	var twBtn = $('.tw__share a');
	var href = twBtn.attr('href');
	var text = encodeURIComponent(twBtn.attr('data-title'));
	var hashtags = 'LXFDLM';
	var via = 'FdlmLuxembourg';
	var shareUrl = 'https://twitter.com/intent/tweet?url=' + href + '&text=' + text + '&hashtags=' +  hashtags + '&via=' + via;

	twBtn.on('click', function(e) {
	  e.preventDefault();
	  var win = window.open(shareUrl, 'ShareOnTwitter', getWindowOptions());
	  win.opener = null;
	});


});